export const profilePage = () => {
    var sectionButtons = document.querySelectorAll('[data-section]');
    if (sectionButtons.length > 0) {
        Array.prototype.slice.call(sectionButtons).forEach(sectionButton => {
            sectionButton.addEventListener('mousedown', toggleSectionInputs)
        })
    }
    var hiddenSectionValue = (<HTMLInputElement>document.getElementById("hidden-section-type"));
    var hiddenUpdateStatus = (<HTMLInputElement>document.getElementById("profile-update-fail"));

    // If error is thrown my MVC model state
    var hiddenfailedProperty = (<HTMLInputElement>document.getElementById("profile-update-fail-property"));

    if (hiddenUpdateStatus && hiddenUpdateStatus.value.toLowerCase() == "true") {
        //MVC MODEL STATE FAILURE
        if (hiddenfailedProperty.value != "") {
            var failedFormPropertyElement = document.querySelectorAll(`[name="${hiddenfailedProperty.value}"]`);
            if (failedFormPropertyElement) {
                var failedComponent = (<HTMLInputElement>failedFormPropertyElement[0]).closest(".ace-my-profile-row-editable");
                var triggerButton = failedComponent.querySelector('[data-section]');
                triggerEvent(triggerButton, "mousedown");
            }
            //TESSITURA FAILURE
        } else if (hiddenSectionValue.value != "") {
            var section = document.querySelectorAll(`[data-section="${hiddenSectionValue.value}"]`)[0];
            triggerEvent(section, "mousedown");
        }
        
    }
}

const triggerEvent = (element: Element, eventName) => {
    var event = new Event(eventName);
    element.dispatchEvent(event);
}
const toggleSectionInputs = (e) => {
    var sectionID = e.currentTarget.getAttribute('data-section');
    var hiddenSectionValue = (<HTMLInputElement>document.getElementById("hidden-section-type"));
    var activeEdit = e.currentTarget.getAttribute('aria-pressed') === 'true';
    var sectionInfo = document.querySelectorAll(`[data-section-info="${sectionID}"]`);
    var sectionInputs = document.querySelectorAll(`[data-section-input="${sectionID}"]`);

    if (hiddenSectionValue)
        hiddenSectionValue.value = sectionID;

    if (sectionInfo.length > 0) {
        sectionInfo[0].setAttribute('aria-hidden', (!activeEdit).toString());
    }

    if (sectionInputs.length > 0) {
        sectionInputs[0].setAttribute('aria-hidden', activeEdit.toString());
    }

    e.currentTarget.setAttribute('aria-pressed', (!activeEdit));

    if (activeEdit) {
        e.currentTarget.innerText = e.currentTarget.getAttribute('data-edit-text');
    } else {
        e.currentTarget.innerText = e.currentTarget.getAttribute('data-cancel-text');
    }

}